import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81317968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ta-transfer" }
const _hoisted_2 = { class: "ta-transfer_left" }
const _hoisted_3 = { class: "transfer-view-head" }
const _hoisted_4 = { class: "head_right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_6 = { class: "transfer-view-main" }
const _hoisted_7 = { class: "ta-transfer_btn" }
const _hoisted_8 = { class: "ta-transfer_right" }
const _hoisted_9 = { class: "transfer-view-head" }
const _hoisted_10 = { class: "head_right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_12 = { class: "transfer-view-main" }
const _hoisted_13 = { class: "dialog-footer" }

import { ref, computed, watch, nextTick } from 'vue';
import { groupFarmerTransfer, groupFarmerAdd } from '../api.js';
import { ElMessage } from 'element-plus';

interface Member {
    key: string;
    label: string;
    disabled: boolean | null;
    originalIndex?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddMembersDialog',
  props: {
    visible: Boolean,
    collectiveId: {
        type: String,
        required: true
    }
},
  emits: ['update:visible', 'confirm', 'cancel'],
  setup(__props, { emit }) {

const props = __props;





const dialogVisible = computed({
    get: () => props.visible,
    set: (value) => emit('update:visible', value),
});

const initializeData = (data: Member[]) => {
    return data.map((item, index) => ({
        ...item,
        originalIndex: index
    }));
};
const transferData = ref<Member[]>([]);
const selectedData = ref<Member[]>([]);
const checkedMembers = ref<string[]>([]);
const checkedSelectedMembers = ref<string[]>([]);
const loading = ref(false);
const leftFilterText = ref('');
const rightFilterText = ref('');

const checkAll = ref(false);
const isIndeterminate = ref(false);
const checkAllSelected = ref(false);
const isIndeterminateSelected = ref(false);

const componentKey = ref(0);
const rightComponentKey = ref(0);

const availableMembers = computed(() => transferData.value.filter(item => !item.disabled));

// 添加排序函数
const sortByOriginalIndex = (a: Member, b: Member) =>
    (a.originalIndex ?? 0) - (b.originalIndex ?? 0);

// filteredLeftData 和 filteredRightData 计算属性
const filteredLeftData = computed(() => {
    const filter = leftFilterText.value.toLowerCase().trim();
    return transferData.value.filter(item =>
        item.label.toLowerCase().includes(filter)
    );
});
watch(leftFilterText, async (newValue) => {
    console.log('搜索文本变化:', newValue);
    console.log('过滤后的数据:', filteredLeftData.value);

    // 强制组件重新渲染
    componentKey.value += 1;

    await nextTick();
    console.log('重新渲染后的数据:', filteredLeftData.value);
});
watch(rightFilterText, async (newValue) => {
    console.log('右侧搜索文本变化:', newValue);
    console.log('右侧过滤后的数据:', filteredRightData.value);

    rightComponentKey.value += 1;

    await nextTick();
    console.log('右侧重新渲染后的数据:', filteredRightData.value);
});
watch(leftFilterText, (newValue) => {
    console.log('搜索文本变化:', newValue);
    console.log('过滤后的数据:', filteredLeftData.value);
});

const filteredRightData = computed(() => {
    const filter = rightFilterText.value.toLowerCase().trim();
    return selectedData.value.filter(item =>
        item.label.toLowerCase().includes(filter)
    ).sort(sortByOriginalIndex);
});

watch(() => props.visible, (newVisible) => {
    if (newVisible) {
        fetchMembersData();
    }
});

const fetchMembersData = () => {
    groupFarmerTransfer({ id: props.collectiveId })
        .then((res: Member[]) => {
            transferData.value = initializeData(res);
        })
        .catch((error) => {
            console.error('Failed to fetch members data:', error);
            ElMessage.error('获取成员数据失败，请重试');
        });
};

const handleCheckAllChange = (val: boolean) => {
    checkedMembers.value = val ? availableMembers.value.map(item => item.key) : [];
    isIndeterminate.value = false;
};

const handleCheckedMembersChange = (value: string[]) => {
    const checkedCount = value.length;
    checkAll.value = checkedCount === availableMembers.value.length;
    isIndeterminate.value = checkedCount > 0 && checkedCount < availableMembers.value.length;
};

const handleCheckAllChangeSelected = (val: boolean) => {
    checkedSelectedMembers.value = val ? selectedData.value.map(item => item.key) : [];
    isIndeterminateSelected.value = false;
};

const handleCheckedSelectedMembersChange = (value: string[]) => {
    const checkedCount = value.length;
    checkAllSelected.value = checkedCount === selectedData.value.length;
    isIndeterminateSelected.value = checkedCount > 0 && checkedCount < selectedData.value.length;
};


const handleTransferToRight = async () => {
    const transferItems = transferData.value.filter(item =>
        checkedMembers.value.includes(item.key) && !item.disabled
    );
    selectedData.value = [...selectedData.value, ...transferItems].sort(sortByOriginalIndex);
    transferData.value = transferData.value
        .filter(item => !checkedMembers.value.includes(item.key) || item.disabled)
        .sort(sortByOriginalIndex);
    checkedMembers.value = [];
    checkAll.value = false;
    isIndeterminate.value = false;

    componentKey.value += 1;
    rightComponentKey.value += 1; 
    
    await nextTick();
    console.log('转移后的左侧数据:', filteredLeftData.value);
    console.log('转移后的右侧数据:', filteredRightData.value);
};


const handleTransferToLeft = async () => {
    const transferItems = selectedData.value.filter(item =>
        checkedSelectedMembers.value.includes(item.key)
    );
    transferData.value = [...transferData.value, ...transferItems].sort(sortByOriginalIndex);
    selectedData.value = selectedData.value
        .filter(item => !checkedSelectedMembers.value.includes(item.key))
        .sort(sortByOriginalIndex);
    checkedSelectedMembers.value = [];
    checkAllSelected.value = false;
    isIndeterminateSelected.value = false;

    componentKey.value += 1;
    rightComponentKey.value += 1; 

    await nextTick();
    console.log('转移后的左侧数据:', filteredLeftData.value);
    console.log('转移后的右侧数据:', filteredRightData.value); 
};

const handleConfirm = () => {
    if (selectedData.value.length === 0) {
        ElMessage.warning('请至少选择一个成员');
        return;
    }

    loading.value = true;
    const params = {
        groupId: props.collectiveId,
        farmerIds: selectedData.value.map(item => item.key)
    };

    groupFarmerAdd(params)
        .then(() => {
            emit('confirm', selectedData.value.map(item => item.key));
            dialogVisible.value = false;
        })
        .catch((error) => {
            console.error('Failed to add members:', error);
            ElMessage.error('添加成员失败，请重试');
        })
        .finally(() => {
            loading.value = false;
        });
};

const handleCancel = () => {
    resetData();
    emit('cancel');
    dialogVisible.value = false;
};

const handleClose = () => {
    resetData();
    dialogVisible.value = false;
};

const resetData = () => {
    checkedMembers.value = [];
    checkedSelectedMembers.value = [];
    selectedData.value = [];
    checkAll.value = false;
    isIndeterminate.value = false;
    checkAllSelected.value = false;
    isIndeterminateSelected.value = false;
    leftFilterText.value = '';
    rightFilterText.value = '';
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    title: "添加成员",
    width: "60%",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_13, [
        _createVNode(_component_el_button, { onClick: handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              indeterminate: isIndeterminate.value,
              modelValue: checkAll.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
              onChange: handleCheckAllChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 机构所有人员 ")
              ]),
              _: 1
            }, 8, ["indeterminate", "modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(checkedMembers.value.length), 1),
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_unref(availableMembers).length), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              modelValue: leftFilterText.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((leftFilterText).value = $event)),
              placeholder: "搜索农户姓名",
              class: "search-input"
            }, null, 8, ["modelValue"]),
            (_openBlock(), _createElementBlock("div", { key: componentKey.value }, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: checkedMembers.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkedMembers).value = $event)),
                onChange: handleCheckedMembersChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredLeftData), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.key,
                      class: "transfer-view-item"
                    }, [
                      _createVNode(_component_el_checkbox, {
                        label: item.key,
                        disabled: item.disabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "disabled"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleTransferToRight,
            disabled: checkedMembers.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 添加 ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleTransferToLeft,
            disabled: checkedSelectedMembers.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 移除 ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_checkbox, {
              indeterminate: isIndeterminateSelected.value,
              modelValue: checkAllSelected.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkAllSelected).value = $event)),
              onChange: handleCheckAllChangeSelected
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 已选人员 ")
              ]),
              _: 1
            }, 8, ["indeterminate", "modelValue"]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(checkedSelectedMembers.value.length), 1),
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(selectedData.value.length), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_input, {
              modelValue: rightFilterText.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rightFilterText).value = $event)),
              placeholder: "搜索已选农户",
              class: "search-input"
            }, null, 8, ["modelValue"]),
            (_openBlock(), _createBlock(_component_el_checkbox_group, {
              modelValue: checkedSelectedMembers.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkedSelectedMembers).value = $event)),
              onChange: handleCheckedSelectedMembersChange,
              key: rightComponentKey.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredRightData), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: "transfer-view-item"
                  }, [
                    _createVNode(_component_el_checkbox, {
                      label: item.key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})